import _ from 'underscore';
import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { CampaignType, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { getFilteredCampaignType } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };

const update = (items) => {
  return _.reduce(items, (result, item) => {
    // eslint-disable-next-line no-param-reassign
    item.children = update(item.children);
    if (item.id === 'ads-and-extensions') {
      result.push({ ..._.omit(item, 'name'), name: _TL_('Extensions') });
    } else {
      result.push(item);
    }
    return result;
  }, []);
};

const updatePageMenuByCampaign = (siteMap, globalCampaignType, currentCampaign, permissions) => {
  const isPmaxCampaign = currentCampaign && currentCampaign.Id ?
    currentCampaign.CampaignType === 'PerformanceMax' :
    false;

  const isAppCampaign = currentCampaign && currentCampaign.Id ?
    currentCampaign.CampaignType === 'App' && permissions.dynamic.UnifiedAppAds:
    false;

  const isGlobalPmaxCampaign = globalCampaignType === CampaignType.PerformanceMax;

  const isGlobalAppCampaign = globalCampaignType === CampaignType.App && permissions.dynamic.UnifiedAppAds;

  if (isGlobalPmaxCampaign || isPmaxCampaign || isAppCampaign || isGlobalAppCampaign) {
    return update(siteMap);
  }

  return siteMap;
};

const updatePageMenuByCampaignCached = memoize(updatePageMenuByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processPmaxCampaignPageMenu(Component) {
  const Wrapper = ({ siteMap, permissions, ...props }) => {
    const globalCampaignType
      = getFilteredCampaignType(props[WaterfallFilterType.CampaignType]);

    const processor = campaign => (<Component
      {...props}
      siteMap={updatePageMenuByCampaignCached(siteMap, globalCampaignType, campaign, permissions)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
  };

  return withPermissions(withGlobalFilter(Wrapper));
}
